const tableTitleCompany = {
  title: 'Empresas',
  placeholder: 'Buscar',
  Typography: 'Ningún resultado encontrado'
};

export default tableTitleCompany;
